import { render, staticRenderFns } from "./ModalFormCancelFolioComponent.vue?vue&type=template&id=f329c262"
import script from "./ModalFormCancelFolioComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormCancelFolioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports